import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FlexBaseComponent } from '@wephone-core-ui';
import { AuthenticationService } from '@wephone-core/service/authentication';
import { UserService } from '@wephone/services/user.service';
import * as _ from 'lodash';
import { FlexIvrSettings } from '@wephone-core/service/flexivr_settings';
import { SigninService } from '@wephone-session/service/signin.service';
import { _ti } from '@wephone-translation';
import { StorageService } from '@wephone-core/service/storage.service';
import { EmailValidator } from '@wephone-utils';
@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss']
})
export class ForgotComponent extends FlexBaseComponent implements OnInit {
  form: FormGroup;
  domainName: string;
  enterpriseName: string;
  errorMessage: string;
  instruction: string;
  isProjectSuperAdmin: boolean;
  linkSignup: string;
  alreadysubmit: boolean;
  constructor(
    private readonly fb: FormBuilder,
    private readonly authService: AuthenticationService,
    private readonly userService: UserService,
    private readonly settings: FlexIvrSettings,
    private readonly signinService: SigninService,
    private readonly storage: StorageService,
    private readonly router: Router
  ) {
    super();
    this.linkSignup = FlexIvrSettings.getInstance().getAbsoluteWSv2URL('/signup');
  }

  async ngOnInit(): Promise<void> {
    this.isProjectSuperAdmin = this.settings.isProjectSuperAdmin();
    this.form = this.fb.group({
      email: [undefined, [Validators.required, EmailValidator]]
    });

    this.domainName = this.signinService.currentDomain;
    if (!this.domainName) {
      this.domainName = await this.authService.getLastDomain();
    }

    if (!this.isProjectSuperAdmin) {
      if (!this.domainName) {
        this.goEnterpriseSelect();
      } else {
        try {
          const res = await this.signinService.getEnterpriseInfo(this.domainName);
          if (res && res.name) {
            this.enterpriseName = res.name;
            // return;
          }
        } catch (e) {
          // this.enterpriseName = this.domainName;
          this.errorMessage = _ti('enterprise.validator.not_found');
          await this.signinService.clearLocalCredential();
          this.authService.gotoLoginPage();
        }
      }
    }

    let username: string = this.signinService.currentUserName;
    if (!username) {
      username = await this.storage.getDomainTempData('user_name', this.domainName);
    }
    this.form.get('email').setValue(username);
    this.form.get('email').valueChanges.subscribe(changes => {
      this.alreadysubmit = false;
    });
  }

  async onSubmit(): Promise<void> {
    try {
      this.errorMessage = undefined;
      this.instruction = undefined;
      console.log('Request reset', this.domainName, this.form.get('email').value);
      const result = await this.userService.requestResetPw(this.domainName, this.form.get('email').value);
      console.log('Request reset response', result);

      // this.dialogService.openDialog2(
      //   RequestResetPwDialogComponent,
      //   {
      //     data: {
      //       domain: this.domainName,
      //       email: this.form.get('email').value,
      //     },
      //     size: 's'
      //   },
      //   (data_dialog: any) => {
      //     console.log('data_dialog', data_dialog);
      //   }
      // );
      this.instruction = 'forgot.title.email_instruction';
      setTimeout(() => {
        this.router.navigate(['/s/signin']);
      }, 3000);
    } catch (e) {
      console.error('Request reset', e);
      const errorCode = e.message ? e.message : undefined;
      const errors: any = {};
      if (_.includes(['invalid_email', 'password_request_inprogress', 'invalid_domain'], errorCode)) {
        errors[errorCode] = true;
      } else {
        errors['unknown'] = errorCode;
      }
      this.form.get('email').setErrors(errors);
    } finally {
      this.alreadysubmit = true;
    }
  }

  goEnterpriseSelect(): void {
    this.router.navigate(['s/enterprise-select'], { queryParams: { returnUrl: '/s/forgot' } });
  }
}
